import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { environment } from "../../environments/environments";
import "./BlogDetailsScreen.css";
import aboutbanners from "../../assets/images/about-head-banner.jpg";
import { FaChevronRight } from 'react-icons/fa';

const BlogDetailsScreen = () => {
  const location = useLocation();
  const { data, index: passedIndex = 0 } = location.state || {};
  const [index, setIndex] = useState(passedIndex);
  const [allBlogs, setAllBlogs] = useState([]);
  const [currentBlog, setCurrentBlog] = useState(data || {});
  const [nextIndex, setNextIndex] = useState(0);

  useEffect(() => {
    const storedData = localStorage.getItem("news");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setAllBlogs(parsed);
      const current = parsed[passedIndex] || {};
      setCurrentBlog(current);
      const next = passedIndex === parsed.length - 1 ? 0 : passedIndex + 1;
      setNextIndex(next);
    }
  }, [passedIndex]);

  useEffect(() => {
    if (allBlogs.length > 0) {
      setCurrentBlog(allBlogs[index]);
      setNextIndex(index === allBlogs.length - 1 ? 0 : index + 1);
    }
  }, [index, allBlogs]);

  const htmlContent = useMemo(() => {
    return currentBlog?.blog_description || currentBlog?.desc || "";
  }, [currentBlog]);

  if (!currentBlog) return <div className="loading"></div>;

  return (
    <div className="blog-details">
      <div className="bannersec"
        style={{
          backgroundImage: `url(${aboutbanners})`,
        }}>
        <h4>Blog Details</h4>
        <p>Home <span><FaChevronRight /></span> Blog Details</p>

      </div>
      <div className="blog-details-containt">
        <div className="top-image-wrapper">
          <img
            src={`${environment.url}uploads/blogs/${currentBlog?.image}`}
            alt="blog"
            className="top-image"
          />
        </div>

        <div className="details-box">
          <h1 className="blog-title">{currentBlog?.title}</h1>
          <div className="blog-content-scrollable">
            <div
              className="blog-content"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetailsScreen;
